// @flow
import config from "global/config"

const isPassportEnabled = config.enablePassport ? true : false

const upsellSubscriptions = config.upsellSubscriptions ? true : false

const showPassportInHomepagePlans = () => isPassportEnabled

const showPassportInSubscriptionPage = () => isPassportEnabled

const showPassportFilter = () => isPassportEnabled

const showPassportBadge = () => isPassportEnabled

const showPassportUpsellInReservationFlow = () => isPassportEnabled

const showPassportUpsellInProductsPage = () => isPassportEnabled

const showSubscriptionUpsellInProductsPage = () => upsellSubscriptions

const showSubscriptionUpsellInReservationFlowPage = () => upsellSubscriptions

const showAboutPlansPage = () => upsellSubscriptions

const featureFlags = {
  showPassportInSubscriptionPage,
  showPassportInHomepagePlans,
  showPassportFilter,
  showPassportBadge,
  showPassportUpsellInReservationFlow,
  showPassportUpsellInProductsPage,
  showSubscriptionUpsellInProductsPage,
  showSubscriptionUpsellInReservationFlowPage,
  showAboutPlansPage,
};

export default featureFlags;



// WEBPACK FOOTER //
// ./src/global/feature-flags.js